import $ from 'jquery';
import processInclude from '../util';
import scrollTo from '../util/scrollTo';
import { updateComponent } from '../util/domutils';
import clientSideValidation from '../components/clientSideValidation';
import { startSpinner } from '../util/fetchutils';
import { loadFormErrors } from './formErrors';

const tabletBreakpoint = 769;
const mobileBreakpoint = 767;

export const SELECTORS = {
  HEADER: '.checkout-header',
  CONTENT: '.checkout',
  PAYMENTFORM: '.payment-container',
  ERRORCONTENT: '.checkout-step__errors',
  STEP_FORM: '.checkout-step__form',
  SHIPPING_FORM: '.checkout-shipping__form',
  BILLING_FORM: '.checkout-billing__form',
  SUMMARY_FORM: '.checkout-summary__form',
  STEP_CONTENT: '.page',
  SHIPPING_TYPE: {
    TYPE: '.checkout-shipping__type',
    CURRENT_TYPE: '.checkout-shipping__type.active',
  },
  SAVED_ADDRESS: {
    SHIPMENT_SELECTOR: '.saved-addresses',
    SAVED_ADDRESS_CONTAINER: '.saved-addresses__pane',
    SAVED_ADDRESS_INPUT: '.saved-addresses__address-input',
  },
  SHIPPING_ADDRESS: {
    FIELDS: '.checkout-shipping__address',
    NEW_FIELDS: '.saved-addresses__new-fields',
    SAVE_TOGGLE: '.checkout-shipping__shipment__save-address',
    get LINE1() { return `${this.FIELDS} #addressOne`; },
    get STATE() { return `${this.FIELDS} #stateCode`; },
    get CITY() { return `${this.FIELDS} #city`; },
    get POSTAL_CODE() { return `${this.FIELDS} #postalCode`; },
  },
  SHIPPING_METHODS: {
    CONTAINER: '.checkout-shipping__method-list',
    METHOD: '.checkout-shipping__method',
    METHOD_INPUT: '.checkout-shipping__method-input',
  },
  GIFT: {
    CONTAINER: '.checkout-shipping__gift',
    INPUT: '.checkout-shipping__gift-input',
    MESSAGE_INPUT: '.checkout-shipping__gift-message',
    MESSAGE_TEXT_AREA: '#giftMessage',
    SYMBOLS_LEFT: '.checkout-shipping__symbols-left-count',
    GIFT_PACKAGING_CHECKBOX: '.checkout-shipping__gift-content',
  },
  BILLING_ADDRESS: {
    CARD: '.checkout-billing__address-card',
    SAME_AS_SHIPPING: '.checkout-billing__copy-shipping-input',
  },
  PAYMENT_METHODS: {
    GIFT_CARD_FORM: '.checkout-billing__gift-card-form',
    GIFT_CARD_FORM_LIST: '.giftcard-payment',
    CREDIT_CARD_FORM: '.checkout-billing__credit-card-form',
    INPUT: '.checkout-billing__payment-input',
    CONTENT: '.checkout-billing__payment-content',
    CREDIT_CARD: {
      DATE: '#expirationDate',
      MONTH: '#expirationMonth',
      YEAR: '#expirationYear',
      NEW_CVV: '.checkout-billing__cvv--new',
      SAVED_CVV: '.checkout-billing__cvv--saved',
      CVV_TOOLTIP: '.checkout-billing__cvv__tooltip-wrapper',
      NEW_LABEL: '.checkout-billing__payment-selector--CREDIT_CARD',
      SAVED_LABEL: '.checkout-billing__payment-selector--SAVED_CREDIT_CARD',
      SAVED_FORM: '.checkout-billing__payment-form--SAVED_CREDIT_CARD',
      SAVED_DROPDOWN_CONTAINER: '.saved-cards__container',
      SAVED_DROPDOWN: '#savedCards',
      NUMBER_GROUP: '.checkout-billing__credit-card-number',
      DATE_GROUP: '.checkout-billing__credit-card-expiry',
      NEW_OPTION: '.checkout-billing__payment--CREDIT_CARD',
    },
    APPLE_PAY: {
      OPTION: '.checkout-billing__payment--DW_APPLE_PAY',
    },
  },
  SUBMIT: '.checkout-billing__submit-btn',
  ERRORS: {
    CONTAINER: '.checkout-step__errors',
    CONTENT: '.error-summary',
  },
  SUMMARY: '.summary',
  PAYMENTSUMMARY: '.paymentTotalSummary',
};

export const EVENTS = {
  SAVED_ADDRESS: {
    ADDRESS_SELECTED: 'savedAddress:selected',
  },
  BILLING: {
    USE_SHIPPING_AS_BILLING_TOGGLED: 'useShippingAsBilling:toggle',
  },
  ADYENCONTENT: 'adyen3dsModalContent',
  UPDATEVIEW: 'checkout:updatedview',
  TRIGGER_SHIPPING_VALIDATION: 'checkout:shippingValidate',
  SHOW_PAYMENT_ERROR: 'checkout:showPaymentError',
};

// Listen for the custom event and execute the error summary code
document.addEventListener(EVENTS.SHOW_PAYMENT_ERROR, () => {
  const urlParams = new URLSearchParams(window.location.search);
  const paymentError = urlParams.get('paymentError') || urlParams.get('PlaceOrderError');
  const errorContainer = document.querySelector('.error-summary-container');

  if (paymentError && errorContainer) {
    // Create the error summary element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'form-group alert alert-danger error-summary';
    errorDiv.innerHTML = `
      <div class="error-icon"></div>
      <div class="error-summary-body">
        ${decodeURIComponent(paymentError)}
      </div>
    `;

    errorContainer.style.display = 'block';
    errorContainer.appendChild(errorDiv);
  }
});

const showComponent = (selector) => {
  const component = document.querySelector(selector);

  if (component) {
    component.classList.remove('d-none');
    scrollTo(component);
  }
};

const hideComponent = (selector) => {
  const component = document.querySelector(selector);

  if (component) {
    component.classList.add('d-none');
  }
};

const checkoutContent = () => {
  let checkoutShippingFormSubmit;
  const addressContent = document.querySelector('#address-content');
  const storeContent = document.querySelector('#store-content');
  const checkoutRedesign = document.querySelector('.checkout-redesign');
  const hubboxContainer = document.querySelector('.hubbox-container');
  const collectPaymentDetails = document.querySelector('.collect-payment-details');
  const paymentContainer = document.querySelector('.payment-container');
  const paymentIndicator = document.querySelector('.checkout__progress-step--payment');

  if (addressContent && addressContent.classList.contains('active')) {
    checkoutShippingFormSubmit = addressContent.querySelector('.checkout-shipping__form-submit-container');
    if (checkoutShippingFormSubmit) checkoutShippingFormSubmit.classList.add('d-none');
    if (checkoutRedesign) checkoutRedesign.classList.add('deliverypayment');
    checkoutRedesign.classList.remove('collectionpayment');
  }

  if (storeContent && storeContent.classList.contains('active')) {
    checkoutShippingFormSubmit = storeContent.querySelector('.checkout-shipping__form-submit-container');
    // eslint-disable-next-line jquery/no-class
    if (!$('.hubbox-container').hasClass('registeredUser')) {
      if (hubboxContainer) hubboxContainer.classList.add('d-none');
      if (collectPaymentDetails) collectPaymentDetails.classList.remove('d-none');
    }
    if (checkoutRedesign) checkoutRedesign.classList.add('collectionpayment');
    checkoutRedesign.classList.remove('deliverypayment');
    if (checkoutShippingFormSubmit) checkoutShippingFormSubmit.classList.add('d-none');
  }

  if (paymentContainer) paymentContainer.classList.remove('d-none');
  if (paymentIndicator) paymentIndicator.classList.add('checkout__progress-step--current');
  if (checkoutRedesign) checkoutRedesign.classList.add('paymentSection');
  const $dialCode = $('#billingdialcode');
  if ($dialCode) {
    // eslint-disable-next-line jquery/no-attr
    const allowedCountries = $dialCode.attr('allowedLocales');
    // eslint-disable-next-line jquery/no-attr
    const defaultCountryCode = $dialCode.attr('defaultCountryCode');
    const $onlyCountries = allowedCountries ? allowedCountries.split(',') : '';
    $('#billingdialcode').intlTelInput({
      allowDropdown: true,
      initialCountry: defaultCountryCode,
      formatOnDisplay: true,
      separateDialCode: true,
      page: 'checkout-page',
      onlyCountries: $onlyCountries,
      dropdownContainer: $('.country-dial-code'),
    });
  }

  document.querySelectorAll('.checkout-container form input').forEach((input) => {
    input.addEventListener('blur', () => {
      input.setCustomValidity('');
      if (!input.validity.valid) {
        // eslint-disable-next-line prefer-destructuring
        let validationMessage = input.validationMessage;
        input.classList.remove('is-valid');
        input.classList.add('is-invalid');
        input.closest('.form-group').classList.add('form-error');
        if (input.validity.patternMismatch && input.dataset.patternMismatch) {
          validationMessage = input.dataset.patternMismatch;
        }
        if ((input.validity.rangeOverflow || input.validity.rangeUnderflow) && input.dataset.rangeError) {
          validationMessage = input.dataset.rangeError;
        }
        if ((input.validity.tooLong || input.validity.tooShort) && input.dataset.rangeError) {
          validationMessage = input.dataset.rangeError;
        }
        if (input.validity.valueMissing && input.dataset.missingError) {
          validationMessage = input.dataset.missingError;
        }
        const formGroup = input.closest('.form-group');
        const feedbackElement = formGroup ? formGroup.querySelector('.invalid-feedback') : null;
        if (feedbackElement) {
          feedbackElement.textContent = validationMessage;
        }
      } else {
        input.classList.remove('is-invalid');
        if (input.value.length > 0) {
          input.classList.add('is-valid');
        } else {
          input.classList.remove('is-valid');
        }
        input.closest('.form-group').classList.remove('form-error');
      }
    });
  });
};

const appendEmptyStage = (selector, content) => {
  const component = document.querySelector(selector);

  if (component) {
    if (content && content.length) {
      const existingContainer = component.querySelector('.checkout-summary');
      if (existingContainer) {
        existingContainer.remove();
      }
      const container = document.createElement('div');
      container.innerHTML = content;
      component.appendChild(container);
    }
  }
};

const handleCreditCardExpiryErrors = (fieldErrors) => {
  const modifiedErrors = Object.assign(fieldErrors);

  const dateField = document.querySelector(SELECTORS.PAYMENT_METHODS.CREDIT_CARD.DATE);
  const monthField = document.querySelector(SELECTORS.PAYMENT_METHODS.CREDIT_CARD.MONTH);
  const yearField = document.querySelector(SELECTORS.PAYMENT_METHODS.CREDIT_CARD.YEAR);

  if (dateField && monthField && yearField) {
    const expiryErrors = Object.keys(modifiedErrors)
      .filter(name => name === monthField.name || name === yearField.name)
      .map(name => modifiedErrors[name]);

    if (expiryErrors.length) {
      modifiedErrors[dateField.name] = expiryErrors.join(' ');
    }
  }

  return modifiedErrors;
};

const processFieldErrors = fieldErrors => handleCreditCardExpiryErrors(fieldErrors);

const redirectTo = (redirectUrl) => {
  const stepForm = document.querySelector(SELECTORS.STEP_FORM);

  if (stepForm) {
    $(stepForm).spinner().start();
  }

  // Executing the redirect in the main thread can cause IE to hang when leaving
  // the site, e.g. to get to a payer auth page
  setTimeout(() => {
    window.location = redirectUrl;
  });
};

export const clientSideValidationUpdate = async () => {
  const shippingForm = document.querySelector(SELECTORS.SHIPPING_FORM);
  clientSideValidation.functions.clearForm(shippingForm, true);
};

export const reinitClientSideValidation = () => {
  processInclude(clientSideValidation);
};

export const isRedirectResponse = (content) => {
  if (content) {
    const errorUrl = content.error && content.redirectUrl;
    const paypalUrl = content.paypalProcessorResult && content.paypalProcessorResult.success && content.paypalBaseUrl;

    return content.continueUrl || paypalUrl || errorUrl;
  }

  return false;
};

export const selectedShippingMethodContent = () => {
  const selectedMethodInput = document.querySelector('.checkout-shipping__method-input:checked');
  const selectedMethodContainer = document.querySelector('.checkout-shipping__selected-shipping-method-container');

  if (selectedMethodInput && selectedMethodContainer) {
    const methodContent = selectedMethodInput.closest('.checkout-shipping__method');
    const nameElement = selectedMethodContainer.querySelector('.checkout-shipping__selected-shipping-method_name');
    const priceElement = selectedMethodContainer.querySelector('.checkout-shipping__selected-shipping-method_price');
    const descriptionElement = selectedMethodContainer.querySelector(
      '.checkout-shipping__selected-shipping-method_description',
    );

    if (methodContent && nameElement && priceElement) {
      const methodName = methodContent.querySelector('.checkout-shipping__method-name');
      const methodPrice = methodContent.querySelector('.checkout-shipping__method-price');
      const methodDescription = methodContent.querySelector('.checkout-shipping__method-description');

      if (methodName && methodPrice) {
        nameElement.innerHTML = methodName.innerHTML;
        priceElement.innerHTML = methodPrice.innerHTML;
      }

      if (descriptionElement && methodDescription) {
        descriptionElement.innerHTML = methodDescription.innerHTML;
      }
    }
  }
};

/**
 * Handles backend responses that contain rendered content for checkout components
 *
 * @param {Object} content Content returned by an AJAX request
 */
export const updateView = async (content) => {
  if (content.continueUrl) {
    redirectTo(content.continueUrl);
    return;
  }

  if (content.paypalProcessorResult && content.paypalProcessorResult.success && content.paypalBaseUrl) {
    redirectTo(content.paypalBaseUrl + content.paypalProcessorResult.paypalToken);
    return;
  }

  if (content.error) {
    if (content.redirectUrl) {
      redirectTo(content.redirectUrl);
      return;
    }

    if (content.errorContent) {
      // This is specific for Onestock Delivery Promise as if no available shipping method then it will show error.
      if (document.querySelectorAll('.onestock-delivery-method-wrapper').length
        && document.querySelectorAll(SELECTORS.ERRORS.CONTENT).length === 0
        && document.querySelector(SELECTORS.ERRORCONTENT)) {
        const errorDiv = document.createElement('div');
        errorDiv.className = 'error-summary';
        document.querySelector(SELECTORS.ERRORCONTENT).appendChild(errorDiv);

        await updateComponent(SELECTORS.ERRORS.CONTENT, content.errorContent, true);
      } else {
        await updateComponent(SELECTORS.ERRORS.CONTENT, content.errorContent);
      }

      showComponent(SELECTORS.ERRORS.CONTAINER);
    }

    if (content.fieldErrors) {
      if (content.fieldErrors.length) {
        content.fieldErrors.forEach((error) => {
          if (Object.keys(error).length) {
            loadFormErrors(document, processFieldErrors(error));
          }
        });
      }
    }
  } else {
    await updateComponent(SELECTORS.ERRORS.CONTENT, '');
    hideComponent(SELECTORS.ERRORS.CONTAINER);
  }

  if (content.addressSelectorContent) {
    await updateComponent(SELECTORS.SAVED_ADDRESS.SHIPMENT_SELECTOR, content.addressSelectorContent);
  }

  if (content.shippingMethodsContent) {
    await updateComponent(SELECTORS.SHIPPING_METHODS.CONTAINER, content.shippingMethodsContent);
    const shippingMethod = document.querySelector('#address-content .checkout-shipping__method');
    if (shippingMethod) {
      const $outerMost = $('.checkout-shipping__method').first();
      // eslint-disable-next-line jquery/no-find
      const $firstInput = $outerMost.find('input').first();
      // eslint-disable-next-line jquery/no-prop, jquery/no-is
      if ($firstInput.prop('disabled') && $('.checkout-shipping__method-input:checked').length === 0) {
        // eslint-disable-next-line jquery/no-prop
        $firstInput.prop('disabled', false);
        // eslint-disable-next-line jquery/no-trigger
        $firstInput.trigger('click');
      }

      if (document.querySelector('.checkout-shipping__selected-shipping-method_body')) {
        selectedShippingMethodContent();
        const selectedMethodInput = document.querySelector('.checkout-shipping__method-input:checked');
        const methodList = document.querySelector('.checkout-shipping__method-list');
        const selectedShippingMethod = document.querySelector('.checkout-shipping__selected-shipping-method-container');
        const selectedShippingMethodChange = document.querySelector('.checkout-shipping__methods-edit');
        if (methodList && selectedShippingMethod && selectedShippingMethodChange) {
          if (!selectedMethodInput) {
            methodList.classList.remove('showSelectedShippingMethod');
            selectedShippingMethod.classList.remove('showSelectedShippingMethod');
            selectedShippingMethodChange.classList.remove('showSelectedShippingMethod');
          } else if (selectedShippingMethod.classList.contains('showSelectedShippingMethod')) {
            // Customer selected shipping method then close the shipping methods container
            methodList.classList.add('showSelectedShippingMethod');
            selectedShippingMethodChange.classList.add('showSelectedShippingMethod');
          } else {
            methodList.classList.remove('showSelectedShippingMethod');
          }
        }
      }
    }
    reinitClientSideValidation(); // Required for HubBox
  }

  if (content.giftContent) {
    await updateComponent(SELECTORS.GIFT.CONTAINER, content.giftContent);
  }

  if (content.billingAddressContent) {
    await updateComponent(SELECTORS.BILLING_ADDRESS.CARD, content.billingAddressContent);
    reinitClientSideValidation();
  }

  if (content.summaryContent) {
    await updateComponent(SELECTORS.SUMMARY, content.summaryContent);
    const $dataObject = $(content.paymentTotalSummary);
    if ($dataObject) {
      // eslint-disable-next-line jquery/no-html, jquery/no-find
      const subTotal = $dataObject.find('.grand-total-sum').html();
      $(SELECTORS.PAYMENTSUMMARY).empty().append($dataObject);
      $('.heading-grand-total-sum').empty().append(subTotal);
    }

    if (content.action !== 'CheckoutShippingServices-UpdateShippingMethodsList'
      && window.innerWidth > mobileBreakpoint && document.querySelector(SELECTORS.SUMMARY)
      && document.querySelector(SELECTORS.SUMMARY).classList.contains('collapse')) {
      document.querySelector(SELECTORS.SUMMARY).classList.remove('collapse');
    }
  }

  if (content.giftCardFormContent) {
    await updateComponent(SELECTORS.PAYMENT_METHODS.GIFT_CARD_FORM, content.giftCardFormContent);
  }

  if (content.giftCardFormContentSubmit) {
    const $giftData = $(content.giftCardFormContentSubmit);
    $(SELECTORS.PAYMENT_METHODS.GIFT_CARD_FORM_LIST).empty().append($giftData);
  }

  if (content.skipStepContent) {
    appendEmptyStage(SELECTORS.CONTENT, content.skipStepContent);
  } else if (content.stepContent) {
    const $urlSource = $('.checkout-shipping__form');
    const spinner = startSpinner($urlSource);
    const $dataObject = $(content.stepContent);
    // eslint-disable-next-line jquery/no-html, jquery/no-find
    const paymentData = $dataObject.find('.checkout-payment').html();
    // eslint-disable-next-line jquery/no-html, jquery/no-find
    const errorContent = $dataObject.find('.checkout-step__errors').html();
    // eslint-disable-next-line jquery/no-find, jquery/no-html
    const errorlength = $dataObject.find('.error-summary').html();
    $(SELECTORS.PAYMENTFORM).empty().append(paymentData);
    if (errorlength) {
      $(SELECTORS.ERRORCONTENT).empty().append(errorContent);
      document.querySelector('.checkout-step__errors').classList.remove('d-none');
      const parentContainer = document.querySelector('.checkout-redesign');
      scrollTo(parentContainer);
    }
    $('.payment-container .checkout-shipping__form').remove();
    reinitClientSideValidation();
    checkoutContent();
    const addressContent = document.querySelector('#address-content');
    const storeContent = document.querySelector('#store-content');
    setTimeout(() => {
      if (addressContent && addressContent.classList.contains('active')) {
        // eslint-disable-next-line jquery/no-css, jquery/no-class
        $('.checkout-shipping__types .store').removeClass('disabled-content');
      }
      if (storeContent && storeContent.classList.contains('active')) {
        // eslint-disable-next-line jquery/no-css, jquery/no-class
        $('.checkout-shipping__types .address').removeClass('disabled-content');
      }
      $(spinner).spinner().stop();
    }, 2000);
  }

  if (content.currentStage !== 'shipping') {
    document.dispatchEvent(new CustomEvent(EVENTS.SHOW_PAYMENT_ERROR));
  }


  if (content.adyenAction) {
    document.dispatchEvent(new CustomEvent(EVENTS.ADYENCONTENT, {
      detail: {
        adyenAction: content.adyenAction,
        orderToken: content.orderToken,
      },
    }));
  }

  document.dispatchEvent(new CustomEvent(EVENTS.UPDATEVIEW, {
    detail: {
      stage: content.currentStage,
      action: content.action,
    },
  }));
};

export const attachCustomValidationEvents = () => {
  document.addEventListener(EVENTS.TRIGGER_SHIPPING_VALIDATION, () => {
    clientSideValidation.functions.validateForm(SELECTORS.SHIPPING_FORM);
  });
};

export const populateStickyOrderSummary = () => {
  const stickySummary = document.querySelector('.summary__container');
  const orderSummary = document.querySelector('.order-sticky-summary-overlay');
  const checkoutStep = document.querySelector('.checkout__step');
  const stickySummaryHeading = document.querySelector('#stickySummaryHeading');

  if (checkoutStep) {
    if (stickySummaryHeading && stickySummary
      && orderSummary && orderSummary.classList.contains('showStickySummary')
      && window.innerWidth < tabletBreakpoint) {
      checkoutStep.before(stickySummary);
      stickySummaryHeading.classList.add('collapse');
    } else {
      checkoutStep.after(stickySummary);
      if (stickySummaryHeading) { stickySummaryHeading.classList.remove('collapse'); }
    }
  }
};

export const setTitleDefaultValue = () => {
  const selectElement = document.querySelector('.checkout-step__billing-form #title');
  if (selectElement && selectElement.selectedIndex > 0) {
    // Set it to the first option
    selectElement.selectedIndex = 0;
  }
};

export const validateFormField = () => {
  const shippingFormFields = document.querySelectorAll('.js-checkout-shipping-field');
  const container = document.querySelector('.error-summary-container');

  if (document.querySelector('.registeredUser')
    && document.querySelector('.js-checkout-shipping-type.address.active')
    && shippingFormFields.length) {
    const invalidElements = [];

    shippingFormFields.forEach((field) => {
      if (!field.value || field.value === 'null' || field.value.trim() === '') {
        const label = field.dataset.label || field.name || '';
        invalidElements.push({ label });
      }
    });

    if (invalidElements.length > 0) {
      if (!container) {
        return;
      }

      container.innerHTML = '';

      const errorMessageInput = document.getElementById('errorSummaryMessage');
      const errorMessage = errorMessageInput.value || 'Missing or incorrect information';

      // Build the summary element
      const summary = document.createElement('div');
      summary.className = 'error-summary-main';

      summary.innerHTML = `
        <div class="error-icon"></div>
        <div class="error-summary-body">
          <p class="error-summary-heading">${errorMessage}</p>
          <ul class="list">
            ${invalidElements.map(({ label }) => `<li class="list-item">${label}</li>`).join('')}
          </ul>
        </div>
      `;

      // Append to DOM
      container.appendChild(summary);
      container.style.display = 'block';

      // Scroll to top smoothly
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (container) {
      container.innerHTML = '';
      container.style.display = 'none';
    }
  }
};

document.addEventListener(EVENTS.BILLING.USE_SHIPPING_AS_BILLING_TOGGLED, setTitleDefaultValue);

document.addEventListener('DOMContentLoaded', populateStickyOrderSummary);

$(document).on('click', '.summary__products-heading', () => {
  if (window.innerWidth < tabletBreakpoint) {
    setTimeout(() => {
      const summaryOverlay = document.querySelector('.order-sticky-summary-overlay');
      const summary = document.querySelector('.summary__container .summary');

      if (summary.classList.contains('collapsing')) {
        summaryOverlay.classList.toggle('showOverlay');
      }
    });
  }
});

window.addEventListener('resize', () => {
  populateStickyOrderSummary();
});

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.js-registered-user')) {
    document.dispatchEvent(new CustomEvent(EVENTS.SHOW_PAYMENT_ERROR));
  }
});
